/* eslint-disable no-console */
import { datadogLogs } from '@datadog/browser-logs';
import { get } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import Settings from 'utils/Settings';

import { DATADOG_LOGGER_SECRETS, SERVICE, ENVIRONMENT, DEFAULT_ATTRIBUTES } from './constants';

const clientToken = get(DATADOG_LOGGER_SECRETS, Settings.environment);

let init = false;

const DataDogLogs = class {
  static init = () => {
    if (!init) {
      const pageId = uuidv4();

      datadogLogs.init({
        clientToken,
        service: SERVICE,
        env: ENVIRONMENT,
        forwardErrorsToLogs: true,
        beforeSend: log => {
          Object.assign(log, { ...DEFAULT_ATTRIBUTES, pageId });
        },
      });
      init = true;
    }
  };

  static info = (message, context = {}, error) => {
    datadogLogs.logger.info(message, context, error);
  };

  static warn = (message, context = {}, error) => {
    datadogLogs.logger.warn(message, context, error);
    console.warn(message, error, context);
  };

  static error = (message, context = {}, error) => {
    const errorMessage = message || error?.message || error || 'no error message';
    datadogLogs.logger.error(errorMessage, context, error);
    console.error(errorMessage, error, context);
  };

  static get sessionId() {
    const logs = datadogLogs.getInternalContext();
    return logs?.session_id;
  }
};

export default DataDogLogs;
